const prefix = 'syncing'
export const SYNCING = `${prefix}`
export const INITIAL_SYNC = `${prefix}/initialising`
